import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip.tsx";
import type { ArtifactComponent } from "@/types/artifacts-view.ts";
import { Video } from "lucide-react";

type VirtualMeetingComponentData = Extract<ArtifactComponent, { type: "virtualMeeting" }>;

const labelFor = (platform: VirtualMeetingComponentData["platform"]): string => {
  switch (platform) {
    case "zoom":
      return "Zoom";
    case "teams":
      return "Teams";
    case "googleMeet":
      return "Google Meet";
  }
};

export const VirtualMeetingBlock = ({ component }: { component: VirtualMeetingComponentData }) => {
  const label = labelFor(component.platform);
  return (
    <div className="flex flex-row gap-2 items-center">
      <Video className="size-5" />
      <div className="flex flex-col gap-2">
        <div className="flex flex-col gap-1">
          {component.url ? (
            <a
              href={component.url.startsWith("http") ? component.url : `https://${component.url}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm @md:text-base text-foreground underline hover:text-blue-600"
            >
              {label}
            </a>
          ) : (
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="text-sm @md:text-base text-foreground underline cursor-help">
                  {label}
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <p>Meeting link will be created once the invitation is sent.</p>
              </TooltipContent>
            </Tooltip>
          )}
        </div>
      </div>
    </div>
  );
};
